/** Регистрация SW только на телефоне. Кэш — оболочка, не сигналы. */

const SW_PATH = '/phone-sw.js';

export function registerPhoneSw(): void {
  if (!('serviceWorker' in navigator)) return;
  void navigator.serviceWorker.register(SW_PATH, { scope: '/' }).catch(() => {
    /* нет файла на стенде — молчим */
  });
}

export function staleFrameNote(): boolean {
  try {
    return sessionStorage.getItem('forq.phone.staleFrame') === '1';
  } catch {
    return false;
  }
}

export function markStaleFrame(on: boolean): void {
  try {
    if (on) sessionStorage.setItem('forq.phone.staleFrame', '1');
    else sessionStorage.removeItem('forq.phone.staleFrame');
  } catch {
    /* */
  }
}
